import 'dayjs/locale/pt-br';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import localeData from 'dayjs/plugin/localeData';
import updateLocale from 'dayjs/plugin/updateLocale';
import dayjs from 'dayjs';
import { languageAtom } from 'atoms';
import { useRecoilValue } from 'recoil';
dayjs.extend(localeData);
dayjs.extend(updateLocale);

dayjs.updateLocale('pt-br', {
  calendar: {
    lastDay: '[Ontem as] LT',
    sameDay: '[Hoje as] LT',
    nextDay: '[Amanhã as] LT',
    lastWeek: '[Última] dddd [as] LT',
    nextWeek: 'dddd [as] LT',
    sameElse: 'L',
  },
});

dayjs.updateLocale('es', {
  calendar: {
    lastDay: '[Ayer a las] LT',
    sameDay: '[Hoy a las] LT',
    nextDay: '[Mañana a las] LT',
    lastWeek: '[El] dddd [pasado a las] LT',
    nextWeek: 'dddd [a las] LT',
    sameElse: 'L',
  },
});

function DayJsConfig() {
  const language = useRecoilValue(languageAtom);

  dayjs.locale(language);
  return null;
}

export default DayJsConfig;
